import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border border-[#e0e0e0] bg-white text-[#1a1a1a] hover:bg-[#f5f5f5]",
        secondary:
          "border border-[#e0e0e0] bg-[#f5f5f5] text-[#1a1a1a] hover:bg-[#e8e8e8]",
        destructive:
          "border border-[#e0e0e0] bg-white text-[#1a1a1a] hover:bg-[#f5f5f5]",
        outline: "border border-[#e0e0e0] bg-white text-[#1a1a1a]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
